<ng-container *transloco="let t; read: 'login'">

  <div *ngIf="loading === true" class="loading">
    <p class="p-text-center"><p-progressSpinner strokeWidth="1"></p-progressSpinner></p>
    <p class="p-text-center">{{ t('loading') }}</p>
  </div>

  <ng-container *ngIf="loading !== true">
    <div *ngIf="acs.length === 0" class="no-acs">
      <p class="p-text-center"><fa-icon [icon]="faExclamationTriangle"></fa-icon></p>
      <p class="p-text-center">{{ t('no_acs_found') }}</p>
    </div>

    <ng-container *ngIf="acs.length > 0">

      <p>{{ t('select_ac') }}</p>
      <div class="table">
        <p-table
          [value]="acs"
          [paginator]="true"
          [rows]="25"
          styleClass="p-datatable-sm"
          rowGroupMode="subheader"
          groupRowsBy="temp"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{ t('ac') }}</th>
              <th>{{ t('date') }}</th>
              <th>{{ t('candidates') }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="groupheader" let-ac>
            <tr pRowGroupHeader>
              <td colspan="3">
                <strong>{{ t(ac.getStatusName().replace('common.', '')) }}:</strong>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-ac>
            <tr (click)="selectAc(ac)" (keyup.enter)="selectAc(ac)" class="pointer" role="link" tabindex="0">
              <td>{{ac.name}} {{ ac.ordernumber }}</td>
              <td>
                <span [ngClass]="{'strong': ac.isToday()}">{{ac.start_time | amDateFormat: 'DD.MM.YYYY hh:mm'}} {{ t('labels.oclock') }}<span *ngIf="userTimezone !== ac.timezone" class="timezone"><br>({{ac.getTimeZoneFullname()}})</span></span>
              </td>
              <td>
                <span *ngFor="let candidate of ac.candidates">
                  {{candidate.fullname}}<br>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

    </ng-container>
  </ng-container>

  <div [ngClass]="{'p-text-right': mode === AcSelectorModes.Change}">
    <button pButton class="p-mt-4" label="{{ t('cancel') }}" (click)="cancelAcList()"></button>
  </div>

</ng-container>
